module.exports = __webpack_public_path__ + "static/media/IntermediateGuidePic.7540c97c.png";